import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      fontWeight: 500,
      fontSize: '14px',
      color: palette.text.secondary
    },
    line1: {
      padding: '10px',
      border: '2px dashed rgba(0, 0, 0, 0.3)',
      borderRadius: palette.borderRadius.default,
      display: 'flex',
      gap: '15px',
      '@media (max-width: 376px)': {
        flexDirection: 'column'
      }
    },
    fullWidth: {
      '@media (max-width: 376px)': {
        '& button': {
          width: '100%'
        }
      }
    },
    step: {
      fontSize: '20px',
      margin: 0,
      '@media (max-width: 768px)': {
        display: 'none'
      }
    },
    text: {
      margin: '0px 0px 6px 0px'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
